import React from "react"
import { Text } from "~components/El"

interface UsernameProps {
  atUsername: string
}

const Username: React.FC<UsernameProps> = ({ atUsername }) => <Text fontSize={12} color="#ababab">({atUsername})</Text>

export default Username
